import { graphql } from 'gql';

export const getCatalogGql = graphql(`
    query catalog($catalogUniqueId: String!) {
        catalog(catalogUniqueId: $catalogUniqueId) {
            actionRequired
            buttonText
            code
            data {
                authoredBy
                createdAt
                id
                name
                subsidiaryId
                subsidiaryName
                type {
                    allowMultiple
                    canCreate
                    methodologies
                    name
                    uniqueId
                }
                uniqueId
                updatedAt
                metadata
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const getCatalogsGql = graphql(`
    query catalogs($skip: Int, $take: Int, $where: CatalogItemDataFilterInput, $order: [CatalogItemDataSortInput!]) {
        catalogs(skip: $skip, take: $take, where: $where, order: $order) {
            items {
                authoredBy
                createdAt
                id
                name
                subsidiaryId
                subsidiaryName
                type {
                    uniqueId
                    name
                    methodologies
                    allowMultiple
                    canCreate
                }
                uniqueId
                updatedAt
            }
            totalCount
        }
    }
`);

export const getCatalogsMethodologyFilterGql = graphql(`
    query catalogsMethodologyFilter(
        $where: FilterValueOfProjectMethodologyEnumFilterInput
        $order: [FilterValueOfProjectMethodologyEnumSortInput!]
    ) {
        catalogsMethodologyFilter(where: $where, order: $order) {
            value
        }
    }
`);

export const getCatalogsNameFilterGql = graphql(`
    query catalogsNameFilter($where: FilterValueOfStringFilterInput, $order: [FilterValueOfStringSortInput!]) {
        catalogsNameFilter(where: $where, order: $order) {
            items {
                value
            }
        }
    }
`);

export const getCatalogSubsidiaryFilterGql = graphql(`
    query catalogSubsidiaryFilter($where: FilterValueOfStringFilterInput, $order: [FilterValueOfStringSortInput!]) {
        catalogSubsidiaryFilter(where: $where, order: $order) {
            items {
                value
            }
        }
    }
`);
